import React from 'react';
import { useTranslation } from 'react-i18next';

const ResendTimer = ({ activeResend, resendEmail, resendingEmail, resendStatus, timeLeft, targetTime }) => {
  const handleResendClick = () => {
    if (activeResend) {
      resendEmail();
    }
  };
const {t} =useTranslation()
  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <div>
        <span style={{ fontSize: '16px', color: '#555' }}>
        <span className='body-3'>   {t("Didn't receive the email?")}</span>
        </span>
        {!resendingEmail && (
          <button
            onClick={handleResendClick}
            disabled={!activeResend}
            style={{
              opacity: !activeResend ? 0.5 : 1,
              textDecoration: 'underline',
              background: 'none',
              border: 'none',
       
              cursor: activeResend ? 'pointer' : 'not-allowed',
              marginLeft: '5px',
            }} className='body-2 text-color-1'
          >
            {t(resendStatus)}
          </button>
        )}
        {resendingEmail && (
          <span style={{ marginLeft: '5px' }}>
            <span className="loader"></span> {/* يمكنك استخدام أي مكون لعرض المحمل */}
          </span>
        )}
      </div>
      {!activeResend && (
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#555' }}>
       <span className='body-3'> {t("Didn't receive the email?")}{' '}</span> 
          <strong>
            {`${timeLeft || targetTime} seconds`}
          </strong>
        </div>
      )}
    </div>
  );
};

export default ResendTimer;
